import { render } from "./TituloPlataformaNew.vue?vue&type=template&id=caa0c57a&scoped=true"
import script from "./TituloPlataformaNew.vue?vue&type=script&lang=js"
export * from "./TituloPlataformaNew.vue?vue&type=script&lang=js"

import "./TituloPlataformaNew.vue?vue&type=style&index=0&id=caa0c57a&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-caa0c57a"]])

export default __exports__